import { API } from "../utils";

export const getRoles = async ({ params }) => {
  const response = API.get("/organization/roles", { params });
  const data = await response;
  return data;
};

export const getRolePermission = async ({ params }) => {
  const response = API.get("/organization/roles/permissions", { params });
  const data = await response;
  return data;
};

export const createRole = async ({ body }) => {
  const response = API.post("/organization/roles", body);
  const data = await response;
  return data;
};

export const deleteRole = async ({ params }) => {
  const response = API.delete(`/organization/roles/${params.id}`);
  const data = await response;
  return data;
};

export const getSingleRole = async ({ params }) => {
  const response = API.get(`/organization/roles/${params.id}`, { params });
  const data = await response;
  return data;
};

export const updateRole = async ({ params, body }) => {
  const response = API.patch(`/organization/roles/${params.id}`, body);
  const data = await response;
  return data;
};

export const restoreRole = async ({ params }) => {
  const response = API.put(`/organization/roles/${params.id}/restore`);
  const data = await response;
  return data;
};
